import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { BiData } from '@wix/da-bi/pkg/events';
import NativeDropdown from '@wix/da-ds/pkg/Dropdown/NativeDropdown';
import { useVerification } from '../../../../VerificationPopup/withVerification';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import { useCopyDeviationLinkClick } from '../../../../utils/hooks/useCopyLinkClick';
import { useElementPlacementForArea } from '../../../ElementPlacementContext';
import { StandardDeviationElementPlacement } from '../../../ElementPlacementContext/variants/standard/types';
import { StandardDeviationElementPlacementContext } from '../../../ElementPlacementContext/variants/standard/context';
import s from './MoreMenuMobileDropdown.scss';
const MoreMenuMobileDropdown = ({ deviation, showReportModal, shareDeviationToPost, unpublishDeviation, actionsWithPopovers })=>{
    var _actionsWithPopovers_addToGroup, _actionsWithPopovers_privateCollection;
    const { t } = useTranslation();
    const placementMap = useElementPlacementForArea(StandardDeviationElementPlacement.PrimaryBarMenu, StandardDeviationElementPlacementContext);
    const { onCopyLinkClick } = useCopyDeviationLinkClick(deviation);
    const { restrictToVerifiedAndLoggedIn } = useVerification();
    const restrictedShareToPost = restrictToVerifiedAndLoggedIn(ReferralType.SHARE_TO_POST, 'submitstatus', ()=>shareDeviationToPost(deviation));
    const onSelect = (value)=>{
        const selectedActionWithPopover = Object.values(actionsWithPopovers).find((actionWithPopover)=>actionWithPopover && actionWithPopover.action.value === value);
        if (selectedActionWithPopover) {
            selectedActionWithPopover.action.onClick && selectedActionWithPopover.action.onClick(undefined);
        } else {
            switch(value){
                case 'copylink':
                    onCopyLinkClick();
                    break;
                case 'sharetopost':
                    restrictedShareToPost();
                    break;
                case 'report':
                    showReportModal(deviation);
                    break;
                case 'unpublish':
                    unpublishDeviation({
                        deviation
                    });
                    break;
                default:
            }
        }
    };
    return /*#__PURE__*/ React.createElement(NativeDropdown, {
        className: s['root'],
        onSelect: onSelect,
        openBiData: BiData({
            evid: 417,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
            sectionname: 'deviation'
        }),
        items: [
            (_actionsWithPopovers_addToGroup = actionsWithPopovers.addToGroup) === null || _actionsWithPopovers_addToGroup === void 0 ? void 0 : _actionsWithPopovers_addToGroup.action,
            (_actionsWithPopovers_privateCollection = actionsWithPopovers.privateCollection) === null || _actionsWithPopovers_privateCollection === void 0 ? void 0 : _actionsWithPopovers_privateCollection.action,
            placementMap.share && {
                value: 'copylink',
                label: t('actionbar.copyLink'),
                biData: BiData({
                    evid: 355,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                    deviationid: deviation.deviationId
                })
            },
            placementMap.share && {
                value: 'sharetopost',
                label: t('actionbar.shareToPost'),
                biData: BiData({
                    evid: 356,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                    social_share: 'da_post',
                    deviationid: deviation.deviationId
                })
            },
            placementMap.report && {
                value: 'report',
                label: t('actionbar.report'),
                biData: BiData({
                    evid: 20,
                    modal_version: 2,
                    deviationid: deviation.deviationId
                })
            },
            placementMap.unpublish && {
                value: 'unpublish',
                label: t('actionbar.unpublish')
            }
        ]
    });
};
MoreMenuMobileDropdown.displayName = 'MoreMenuMobileDropdown';
export default MoreMenuMobileDropdown;

//# sourceMappingURL=MoreMenuMobileDropdown.js.map